var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('router-link',{directives:[{name:"ym-report",rawName:"v-ym-report:[reportKey]",arg:_vm.reportKey}],staticClass:"back-to-activity-index-btn",class:[
                ("back-to-activity-index-btn--" + _vm.targetType),
                { 'in-pc': _vm.isPC, }
             ],attrs:{"to":"https://m.youthmba.com/marketing/common/activity/springCourse2021"}},[(_vm.status === 'birthday')?[_vm._v("\n    回到「七周年庆钜惠活动」首页\n  ")]:[_vm._v("\n    回到活动首页\n  ")]],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }